import React from 'react';
import { ShoppingCart, User, Menu } from 'lucide-react';
export function Header() {
  return <header className="w-full border-b border-gold/20 bg-ivory sticky top-0 z-50" data-id="element-25">
      <div className="bg-ink py-2.5 overflow-hidden marquee-pause" data-id="element-26">
        <div className="flex w-max animate-marquee" data-id="element-27">
          {[0, 1].map(dup => <ul key={dup} className="flex items-center shrink-0" aria-hidden={dup === 1} data-id="element-28">
              {['Recomendado por expertos en salud metabólica', 'Basado en evidencia científica', 'Acceso inmediato y seguro', 'Más de 10.000 lectores', 'Guía educativa · No sustituye consulta médica'].map((msg, i) => <li key={i} className="flex items-center text-xs tracking-[0.2em] font-medium text-gold uppercase whitespace-nowrap" data-id="element-29">
                  <span className="px-8" data-id="element-30">{msg}</span>
                  <span className="text-gold/40" data-id="element-31">✦</span>
                </li>)}
            </ul>)}
        </div>
      </div>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-32">
        <div className="flex justify-between items-center h-20" data-id="element-33">
          <div className="flex items-center" data-id="element-34">
            <button className="sm:hidden p-2 text-ink hover:text-gold transition-colors" data-id="element-35">
              <Menu className="h-6 w-6" data-id="element-36" />
            </button>
            <a href="#" className="text-2xl sm:text-3xl font-serif text-ink ml-2 sm:ml-0 tracking-wide" data-id="element-37">
              METABOLIC<span className="text-gold italic" data-id="element-38">Science</span>
            </a>
          </div>

          <nav className="hidden sm:flex space-x-10" data-id="element-39">
            <a href="#" className="text-xs tracking-[0.15em] uppercase font-medium text-ink hover:text-gold transition-colors" data-id="element-40">
              La Guía
            </a>
            <a href="#" className="text-xs tracking-[0.15em] uppercase font-medium text-ink hover:text-gold transition-colors" data-id="element-41">
              Cómo Funciona
            </a>
            <a href="#" className="text-xs tracking-[0.15em] uppercase font-medium text-ink hover:text-gold transition-colors" data-id="element-42">
              Testimonios
            </a>
            <a href="#" className="text-xs tracking-[0.15em] uppercase font-medium text-ink hover:text-gold transition-colors" data-id="element-43">
              FAQ
            </a>
          </nav>

          <div className="flex items-center space-x-6" data-id="element-44">
            <button className="text-ink hover:text-gold transition-colors" data-id="element-45">
              <User className="h-5 w-5 stroke-[1.5]" data-id="element-46" />
            </button>
            <a href="https://newdigitalguide.com/products/peptidos-glp-1-y-perdida-de-peso-guia-educativa" aria-label="Ir al carrito" className="text-ink hover:text-gold transition-colors" data-id="element-47">
              <ShoppingCart className="h-5 w-5 stroke-[1.5]" data-id="element-48" />
            </a>
          </div>
        </div>
      </div>
    </header>;
}